import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

interface Transaction {
    amount: number;
    note: string;
    user_fullName: string;
    creation_type: string;
    action_type: string;
    entry_type: string;
    status: string;
    payment_date: string;
    type: string;
    currency: string;
    dateScheduled: string;
    dateCreation: string;
}

interface Option { id: number; name: string }
interface Brand extends Option {shortName: string}
interface EntryType extends Option {}
interface Role extends Option{}
interface ValnetSupportSplitOption extends Option {}

export class transactionsRecurringList_template extends vnTemplate{

    protected deleteTransactionId: number;


    protected brandFilter: multipleSelector_template;
    protected entryTypeFilter: multipleSelector_template;
    protected roleFilter: multipleSelector_template;
    protected valnetSupportSplit: filterDropdown_template;

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    public validationsList: validationsList_template;

    protected resultInfos: resultsInfo_template;



    protected getTemplateHtml(): string{

        return `
            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div><label class="form-label form-label-box">Valnet Support Split</label>  ${ this.valnetSupportSplit.getHtmlBuild() }</div>
                        <div> ${ this.brandFilter.getHtmlBuild() }</div>
                        <div> ${ this.entryTypeFilter.getHtmlBuild() }</div>           
                        <div> ${ this.roleFilter.getHtmlBuild() }</div>
                    </div>
                </div>      
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-entry-types"></div>
                    <div id="selected-roles"></div>
                    <div id="selected-item-types"></div>
                    <div id="selected-channels"></div>
                </div>
            </div>
            
            ` + this.validationsList.getHtmlBuild() + `

            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Rules</button>
                </div>
                <div class="w-center">
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>          
                </div>
                
                <div class="w-right">
                    `+ this.pagination.getHtmlBuild() + `
                </div>
            </div>
            
            <div class="w-list-result" id="list-results">
                <table class="list-results" >
                ` + this.resultInfos.getHtmlBuild() +`
                    <thead>
                        <tr>
                            
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'user_fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='user_fullName_DESC', 'list-sort-asc': orderByAndDirection()=='user_fullName_ASC'}">user</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'amount') }, css: { 'list-sort-desc': orderByAndDirection()=='amount_DESC', 'list-sort-asc': orderByAndDirection()=='amount_ASC'}">amount</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'note') }, css: { 'list-sort-desc': orderByAndDirection()=='note_DESC', 'list-sort-asc': orderByAndDirection()=='note_ASC'}">note</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency') }, css: { 'list-sort-desc': orderByAndDirection()=='currency_DESC', 'list-sort-asc': orderByAndDirection()=='currency_ASC'}">currency</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreation') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreation_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreation_ASC'}">updated on</span></th>
                            <th class="button align-right"><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: transactions">
                        <tr class="cursor">
                            
                            <td data-bind="event: { click: $parent.onClickEdit }" class="user_fullName"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: user_fullName"></a></span></td>
                            <td data-bind="event: { click: $parent.onClickEdit }" class="amount"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: amount"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }" class="note"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: note"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }" class="currency"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: currency"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }" class="payment_date"><a class="right-click" data-bind="attr: { href : emakiEdit }"><span data-bind="text: dateCreation"></span></a></td>
                            <td class="button align-right">
                                <button data-bind="event: { click: $parent.onClickDelete }" type="button" class="btn border only-icon icon i-delete"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div id="delete-dialog" class="w-lightbox dark-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3>Delete Recurring Transaction</h3>
                            <button data-bind="event: { click: onClickDeleteDialogHide }" type="button" class="close-btn icon i-close"></button>
                        </div>
                   
                        <div class="form-body">
                                <p class="dark">This action is irreversible</p>
                                <p class="dark">Are you sure you want to permanently delete this recurring transaction?</p>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickDeleteDialogHide }" class="btn light half" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickDeleteConfirm }" class="btn highlight half" type="button">Delete</button>
                        </div>
                    </div>
                    
                </div>
            </div>
            `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.valnetSupportSplit = new filterDropdown_template("valnetSupportSplit", this.getTemplateViewModel(), this.caller);

        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Brands");
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brands');
        this.brandFilter.setTagContainerCaption('Selected brands:');

        this.entryTypeFilter = new multipleSelector_template("entryTypeFilter", this.getTemplateViewModel(), this.caller);
        this.entryTypeFilter.setLabel("Entry types");
        this.entryTypeFilter.setFilterContainerClass('margin-neg');
        this.entryTypeFilter.setTagContainerId('selected-entry-types');
        this.entryTypeFilter.setTagContainerCaption('Selected entry types:');

        this.roleFilter = new multipleSelector_template("roleFilterRecurring", this.getTemplateViewModel(), this.caller);
        this.roleFilter.setLabel("Roles");
        this.roleFilter.setFilterContainerClass('margin-neg');
        this.roleFilter.setTagContainerId('selected-roles');
        this.roleFilter.setTagContainerCaption('Selected roles:');
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{
        return "transactionsRecurringList-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the view model data/ functions
        let self = this;
        return {
            orderBy: ko.observable("dateCreation"),
            orderByDirection: ko.observable("DESC"),
            transactions: ko.observableArray([]),
            orderByAndDirection: ko.observable("dateCreation_DESC"),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickEdit: function (data, event) {
                self.onClickEdit(data);
            },
            onClickDeleteConfirm: function (data, event) {
                self.onClickDeleteConfirm();
            },
            onClickDeleteDialogHide: function (data, event) {
                self.onClickDeleteDialogHide();
            },
            onClickDelete: function (data, event) {
                self.onClickDelete(data, event);
            },
            onClickAdd: function () {
                self.onClickAdd();
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
            pagination : this.getTemplateViewModel().pagination,
            list: {
                orderBy: this.getTemplateViewModel().orderBy,
                orderByDirection: this.getTemplateViewModel().orderByDirection,
                orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            },
            filter: {
                keyword : this.getTemplateViewModel().filter.filterKeyword,
                valnetSupportSplit: this.getTemplateViewModel().valnetSupportSplit.selectedOption,
                brands: this.getTemplateViewModel().brandFilter.selectedItems,
                entryTypes: this.getTemplateViewModel().entryTypeFilter.selectedItems,
                roles: this.getTemplateViewModel().roleFilterRecurring.selectedItems
            }
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionListReorder();
    }

    public onClickEdit(data){
        this.caller.editTransaction(data);
    }

    public setTransactions(transactions: Array<Transaction>): void{

        this.viewModel[this.idElement].transactions(transactions);
    }

    public onClickAdd(){
        this.caller.addTransaction();
    }

    public onClickDeleteConfirm() {
        this.toggleDeleteDialogVisibility();
        this.caller.deleteTransaction(this.deleteTransactionId);
    }
    public onClickDeleteDialogHide() {
        this.toggleDeleteDialogVisibility();
    }
    public onClickDelete(data, event) {

        event.stopPropagation();

        this.deleteTransactionId = data.id;
        this.toggleDeleteDialogVisibility();
    }
    public onClickDeleteDialogShow(data) {
        this.deleteTransactionId = data.id;
        this.toggleDeleteDialogVisibility();
    }
    public toggleDeleteDialogVisibility() {
        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


    public setValnetSupportSplitOptions(options:  Array<ValnetSupportSplitOption>): void {

        this.valnetSupportSplit.setOptions(options);
    }

    public setBrandFilterItems(brands: Array<Brand>): void {

        let brandsList = [];
        for (let brand of brands) {
            brandsList.push({id: brand.shortName, name: brand.name});
        }

        this.brandFilter.setItems(brandsList);
        this.brandFilter.setTags(this.brandFilter.getSelectedItems(), brandsList);
    }

    public setEntryTypeFilterItems(entryTypes: Array<EntryType>): void {

        this.entryTypeFilter.setItems(entryTypes);
        this.entryTypeFilter.setTags(this.entryTypeFilter.getSelectedItems(), entryTypes);
    }

    public setRoleFilterItems(roles: Array<Role>): void {

        this.roleFilter.setItems(roles);
        this.roleFilter.setTags(this.roleFilter.getSelectedItems(), roles);
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsRecurringList_template.ts